<template>
  <div class="cloud-Detail" ref="container">
    <!-- 隧道信息 -->
    <div class="panel cloud-detail-title">
      <div class="panel-header">
        <img src="@/assets/images/groupTitle.png" alt="" />
        <p>隧道信息</p>
        <ul
          v-if="
            TunnelsData.itemTunnelType === '4' ||
            TunnelsData.itemTunnelType === '5'
          "
          class="tunnel-tabs"
        >
          <li
            :class="{ active: itemTunnelTypeNUm === '1' }"
            @click="handleTunnelClick(1, '1')"
          >
            右洞
          </li>
          <li
            :class="{ active: itemTunnelTypeNUm === '2' }"
            @click="handleTunnelClick(-1, '2')"
          >
            左洞
          </li>
        </ul>
        <ul v-else-if="TunnelsData.itemTunnelType === '3'" class="tunnel-tabs">
          <li
            :class="{ active: itemTunnelTypeNUm === '3' }"
            @click="handleTunnelClick(2, '3')"
          >
            右洞
          </li>
          <li
            :class="{ active: itemTunnelTypeNUm === '4' }"
            @click="handleTunnelClick(1, '4')"
          >
            左洞
          </li>
          <li
            :class="{ active: itemTunnelTypeNUm === '5' }"
            @click="handleTunnelClick(0, '5')"
          >
            斜井
          </li>
        </ul>
        <ul v-else-if="TunnelsData.itemTunnelType === '7'" class="tunnel-tabs">
          <li
            :class="{ active: itemTunnelTypeNUm === '6' }"
            @click="handleTunnelClick(4, '6')"
          >
            右洞2
          </li>
          <li
            :class="{ active: itemTunnelTypeNUm === '7' }"
            @click="handleTunnelClick(3, '7')"
          >
            左洞2
          </li>
          <li
            :class="{ active: itemTunnelTypeNUm === '8' }"
            @click="handleTunnelClick(2, '8')"
          >
            右洞1
          </li>
          <li
            :class="{ active: itemTunnelTypeNUm === '9' }"
            @click="handleTunnelClick(1, '9')"
          >
            左洞1
          </li>
          <li
            :class="{ active: itemTunnelTypeNUm === '10' }"
            @click="handleTunnelClick(0, '10')"
          >
            斜井
          </li>
        </ul>
      </div>

      <div class="panel-body">
        <div class="safety-day">
          <img src="@/assets/images/attendance_greens.png" alt="" />
          <p style="font-family: DS-Digital, electronicFont">
            {{ daysPassed + 1 }}<span>天</span>
          </p>
          <p>安全天数</p>
        </div>

        <div class="info-item">
          <span class="label">隧道名称</span>
          <span class="value">{{ tunnelData[nun]?.tunnelName }}</span>
        </div>
        <div class="info-item">
          <span class="label">起始里程</span>
          <span class="value">{{ tunnelData[nun]?.startingMileage }}</span>
        </div>
        <div class="info-item">
          <span class="label">工期开始</span>
          <span class="value">{{ tunnelData[nun]?.beginTime }}</span>
        </div>
        <div class="info-item">
          <span class="label">工期结束</span>
          <span class="value">{{ tunnelData[nun]?.plannedEndTime }}</span>
        </div>
      </div>
    </div>

    <!-- 隧道进度 -->
    <div class="panel cloud-detaillz-title">
      <div class="panel-header">
        <img src="@/assets/images/groupTitle.png" alt="" />
        <p>隧道进度</p>
      </div>
      <div class="panel-body">
        <div class="progress-info">
          <span>{{ tunnelData[nun]?.tunnelName }}</span>
          <span>已挖：{{ tunnelData[nun]?.excavationTotalCompleted }}m</span>
        </div>
        <el-progress
          :percentage="handlePercentage(tunnelData[nun]?.progress)"
          :stroke-width="15"
          color="#58DEFF"
        />
      </div>
    </div>

    <!-- 台车洞内信息 -->
    <div class="panel cloud-detailbottom-title">
      <div class="panel-header">
        <img src="@/assets/images/groupTitle.png" alt="" />
        <p>台车洞内信息</p>
      </div>
      <div class="panel-body">
        <ul class="jumbo-list">
          <li>
            <img :src="tunnelData[nun]?.excavationJumboData?.image" alt="" />
            <p>{{ tunnelData[nun]?.excavationJumboData?.name }}</p>
            <p>{{ tunnelData[nun]?.excavationJumboData?.tunnelName }}</p>
            <p>
              <el-progress
                :text-inside="true"
                :stroke-width="15"
                 status="exception"
                :percentage="(tunnelData[nun]?.excavationJumboData?.mileage / tunnelData[nun]?.tunnelLength) * 100"
                :format="customExcavationFormat"
              >
              </el-progress></p>
          </li>
          <li>
            <img :src="tunnelData[nun]?.invertedarchData?.image" alt="" />
            <p>{{ tunnelData[nun]?.invertedarchData?.name }}</p>
            <p>{{ tunnelData[nun]?.invertedarchData?.tunnelName }}</p>
            <p>
              <el-progress
                :text-inside="true"
                :stroke-width="15"
                :percentage="(tunnelData[nun]?.invertedarchData?.mileage / tunnelData[nun]?.tunnelLength) * 100"
                :format="customInvertedarchFormat"
              >
              </el-progress></p>
          </li>
          <li>
            <img :src="tunnelData[nun]?.secondliningJumboData?.image" alt="" />
            <p>{{ tunnelData[nun]?.secondliningJumboData?.name }}</p>
            <p>{{ tunnelData[nun]?.secondliningJumboData?.tunnelName }}</p>
            <p>
              <el-progress
                :text-inside="true"
                :stroke-width="15"
                status="warning"
                :percentage="(tunnelData[nun]?.secondliningJumboData?.mileage / tunnelData[nun]?.tunnelLength) * 100"
                :format="customSecondliningFormat"
              >
              </el-progress>
            </p>
          </li>
        </ul>
      </div>
    </div>

    <!-- iframe 地图 -->
    <iframe class="map-iframe" :src="srcPath" frameborder="0"></iframe>

    <!-- 人机管理 -->
    <div class="panel cloud-detailTightTop-title">
      <div class="panel-header with-decoration">
        <img src="@/assets/images/groupTitle.png" alt="" />
        <p>人机管理</p>
        <dv-decoration-3
          class="decoration-container"
          :style="{ width: '23%', height: '30px' }"
          style="position: absolute; top: 1px; margin-left: 76%"
        >
          <!-- 插槽中添加多个小方块 -->
          <div slot="content" class="squares-container">
            <div class="square s1"></div>
            <div class="square s2"></div>
            <div class="square s3"></div>
            <div class="square s4"></div>
            <div class="square s5"></div>
            <div class="square s6"></div>
          </div>
        </dv-decoration-3>
      </div>
      <div class="panel-body flex-row">
        <div id="main_Personnel" class="chart-container"></div>
        <div class="personnel-toggle">
          <div class="toggle-buttons">
            <p :class="{ active: activeIndex === 0 }" @click="activeIndex = 0">
              洞内人员数({{ humanMachineData.personnelData?.length }})
            </p>
            <p :class="{ active: activeIndex === 1 }" @click="activeIndex = 1">
              洞内车辆数(0)
            </p>
          </div>
          <ul class="detail-list" v-if="activeIndex === 0">
            <li
              v-for="(item, index) in humanMachineData.personnelData"
              :key="index"
            >
              <span class="dot"></span>
              <span>{{ item.name }}</span>
              <span>{{ item.value }}人</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 气体监控 -->
    <div class="panel cloud-detailTightZj-title">
      <div class="panel-header with-decoration">
        <img src="@/assets/images/groupTitle.png" alt="" />
        <p>气体监控信息</p>
        <dv-decoration-3
          class="decoration-container"
          :style="{ width: '23%', height: '30px' }"
          style="position: absolute; top: 1px; margin-left: 76%"
        >
          <div slot="content" class="squares-container">
            <div class="square s1"></div>
            <div class="square s2"></div>
            <div class="square s3"></div>
            <div class="square s4"></div>
            <div class="square s5"></div>
            <div class="square s6"></div>
          </div>
        </dv-decoration-3>
      </div>
      <div class="panel-body">
        <div class="gas-table-header">
          <span>气体名称</span>
          <span>区域</span>
          <span>数值/单位</span>
          <span>上/下限</span>
          <span>更新时间</span>
        </div>
        <div class="scroll-container">
          <ul class="scroll-list">
            <li
              class="gas-table-row"
              v-for="(item, index) in gasNetworkingData"
              :key="index"
            >
              <span style="color: aqua">{{ item.name }}</span>
              <span>{{
                item.regional.substring(item.regional.length - 4)
              }}</span>
              <span>{{ item.value }}{{ item.unit }}</span>
              <span>
                <span
                  v-if="item.openHighAlarm === '0' && item.openLowAlarm === '0'"
                >
                  {{ item.highAlarmValue }}/{{ item.lowAlarmValue }}
                </span>
                <span
                  v-else-if="
                    item.openHighAlarm === '0' && item.openLowAlarm === '1'
                  "
                >
                  {{ item.highAlarmValue }}/-
                </span>
                <span
                  v-else-if="
                    item.openHighAlarm === '1' && item.openLowAlarm === '0'
                  "
                >
                  -/{{ item.lowAlarmValue }}
                </span>
                <span v-else>-</span>
              </span>
              <span>{{ formatDateHis(item.time, "hh:mm:ss") }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 出勤人员 -->
    <div class="panel cloud-detailTightBottom-title">
      <div class="panel-header with-decoration">
        <img src="@/assets/images/groupTitle.png" alt="" />
        <p>出勤人员情况</p>
        <dv-decoration-3
          class="decoration-container"
          :style="{ width: '23%', height: '30px' }"
          style="position: absolute; top: 1px; margin-left: 76%"
        >
          <div slot="content" class="squares-container">
            <div class="square s1"></div>
            <div class="square s2"></div>
            <div class="square s3"></div>
            <div class="square s4"></div>
            <div class="square s5"></div>
            <div class="square s6"></div>
          </div>
        </dv-decoration-3>
      </div>
      <div class="panel-body">
        <div class="job-count">
          <span>在职人员人数</span>
          <span>{{ AttendData.jobNumber }}人</span>
        </div>
        <div class="scroll-container" style="height: 90%">
          <ul class="scroll-list">
            <li
              class="attend-row"
              v-for="(item, index) in AttendData.data"
              :key="index"
            >
              <span style="color: aqua">{{ item.name }}</span>
              <span>{{ item?.tunnelName }}</span>
              <span>{{ item.post }}</span>
              <span>{{ formatDateAll(item.dateTime, "hh:mm") }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  tunnelProgress,
  attendanceData,
  gasData,
  humanMachine,
  getGasNetworking,
} from "@/public/api.js";
import {
  formatMileageUint,
  formatDateAll,
  formatDateHis,
  handlePercentage,
  getRandomNumber,
  getLocalStorageWithExpiry,
} from "@/utils/index";
import excavationJumbo from "@/assets/images/excavationJumbo.png";
import invertedarch from "@/assets/images/invertedarch.png";
import secondliningJumbo from "@/assets/images/secondliningJumbo.png";
import { gasType } from "./page/gas/getType.js";
import { TunnelProgressTestData } from "./components/testData/TunnelProgress";

// 引入路由实例
export default {
  name: "Detail",
  components: {},
  data() {
    return {
      activeIndex: 0,
      itemTunnelTypeNUm: "1",
      myChart: null,
      tunnelData: [],
      gasDataList: [],
      projectCarList: [],
      gasNetworkingDataAll: [],
      gasNetworkingData: [],
      humanMachineData: {
        personnelNumber: 0, // 人员数量
        carNumber: 0, // 车辆数量
        personnelData: [], // 人员数据
        carData: [], // 车辆数据
      },
      daysPassed: 0, // 安全天数
      nun: 0,
      TunnelsData: {},
      AttendData: {
        jobNumber: 0, // 在职人员人数
        wordNumber: 0, // 当前洞内人数
        data: [], // 数据
      },
      srcPath: "",
      interval: null,
    };
  },
  computed: {},
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    let that = this;

    let hostName = window.location.hostname;
    that.TunnelsData = JSON.parse(localStorage.getItem("updateLhTunnels"));
    let tunnelListData = [];
    tunnelProgress({ itemId: that.TunnelsData.itemId }).then((res) => {
      if (res.data.code == 200) {
        let tunnelProgressTestDatas = null;
        if (
          window.location.hostname == "127.0.0.1" ||
          window.location.hostname == "39.100.79.198" ||
          window.location.hostname == "sd.yongsixinxi.com"
        ) {
          tunnelProgressTestDatas = TunnelProgressTestData();
        } else {
          tunnelProgressTestDatas = res.data.data;
        }

        let excavationJumboData = {};
        let invertedarchData = {};
        let secondliningJumboData = {};

        tunnelProgressTestDatas.forEach((item, index) => {
          excavationJumboData = {
            tunnelName: (() => {
              const mileageStr = String(item?.tunnelName);
              return mileageStr.length > 6 ? mileageStr.slice(-7) : mileageStr;
            })(),
            name: "开挖",
            image: excavationJumbo,
            mileage: item.excavation.totalCompleted.toFixed(2),
          };

          invertedarchData = {
            tunnelName: (() => {
              const mileageStr = String(item?.tunnelName);
              return mileageStr.length > 6 ? mileageStr.slice(-7) : mileageStr;
            })(),
            name: "仰拱",
            image: invertedarch,
            mileage: item.invert.totalCompleted.toFixed(2),
          };

          secondliningJumboData = {
            tunnelName: (() => {
              const mileageStr = String(item?.tunnelName);
              return mileageStr.length > 6 ? mileageStr.slice(-7) : mileageStr;
            })(),
            name: "衬砌",
            image: secondliningJumbo,
            mileage: item.lining.totalCompleted.toFixed(2),
          };

          that.tunnelData.push({
            tunnelName: item?.tunnelName,
            startingMileage: formatMileageUint(
              item.startingMileage,
              item.pileNoMark
            ),
            beginTime: that.TunnelsData.planBeginDate,
            plannedEndTime: that.TunnelsData.planCompleteDate,
            tunnelLength: item.tunnelLength,
            excavationTotalCompleted: item.excavation.totalCompleted,
            progress: Math.round(
              (item.excavation.totalCompleted / item.tunnelLength) * 100
            ),
            tunnelNumber: item.tunnelNumber,
            tunnelType: item.tunnelType,
            secondliningJumboData: secondliningJumboData,
            excavationJumboData: excavationJumboData,
            invertedarchData: invertedarchData,
          });

          tunnelListData.push({
            tunnelName: item?.tunnelName,
            startingMileage: formatMileageUint(
              item.tunnelLength,
              item.pileNoMark
            ),
            beginTime: that.TunnelsData.planBeginDate,
            plannedEndTime: that.TunnelsData.planCompleteDate,
            tunnelLength: item.tunnelLength,
            excavationTotalCompleted: item.excavation.totalCompleted,
            progress: Math.round(
              (item.excavation.totalCompleted / item.tunnelLength) * 100
            ),
            tunnelNumber: item.tunnelNumber,
            tunnelType: item.tunnelType,
          });
        });
        localStorage.setItem("tunnelListData", JSON.stringify(tunnelListData)); // 序列化存储
      }
    });

    console.debug(that.tunnelData, "that.tunnelData");
    //安全天数
    const target = new Date(that.TunnelsData.planBeginDate);
    target.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    that.daysPassed = Math.floor((today - target) / (24 * 60 * 60 * 1000));

    let hostNames = window.location.hostname;
    this.interval = setInterval(() => {
      that.getAttendanceData();
      that.getHumanMachine();
      if (
        hostNames == "127.0.0.1" ||
        hostNames == "39.100.79.198" ||
        hostNames == "sd.yongsixinxi.com"
      ) {
        that.gasNetworkingData = [];
        gasType().forEach((item) => {
          that.gasNetworkingData.push({
            regional: item.regional,
            position: item.position,
            name: item.name,
            nameAlias: item.nameAlias,
            value: item.value,
            unit: item.unit,
            highAlarmValue: item.highAlarmValue,
            lowAlarmValue: item.lowAlarmValue,
            openAlarmValue: "0",
            openHighAlarm: "0",
            openLowAlarm: "0",
            alarmValue: item.alarmValue,
            maxValue: item.maxValue,
            minValue: item.minValue,
            tunnelId: item.tunnelId,
            tunnelNumber: item.tunnelNumber,
            creationTime: new Date(),
          });
        });
      } else {
        that.getGasList();
      }
      that.getHumanMachine();
    }, 5000);

    that.getGasNetworkings();
    that.getAttendanceData();
    that.getHumanMachine();

    if (
      hostName == "127.0.0.1" ||
      hostName == "39.100.79.198" ||
      hostName == "sd.yongsixinxi.com"
    ) {
      hostName = "https://" + "3d.yongsixinxi.com";
    } else {
      hostName = "http://39.101.122.159:9990";
    }

    if (this.TunnelsData.itemTunnelType == "1") {
      this.srcPath =
        hostName +
        "/tunnelModelLeft?id=" +
        getRandomNumber(1000) +
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
    } else if (this.TunnelsData.itemTunnelType == "2") {
      this.srcPath =
        hostName +
        "/tunnelModelRight?id=" +
        getRandomNumber(1000) +
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
    } else if (this.TunnelsData.itemTunnelType == "3") {
      this.srcPath =
        hostName +
        "/tunnelModelXj?id=" +
        getRandomNumber(1000) +
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
    } else if (this.TunnelsData.itemTunnelType == "5") {
      this.srcPath =
        hostName +
        "/tunnelModelSx?id=" +
        getRandomNumber(1000) +
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
    } else if (this.TunnelsData.itemTunnelType == "4") {
      this.srcPath =
        hostName +
        "/tunnelModelStd?id=" +
        getRandomNumber(1000) +
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
    } else if (this.TunnelsData.itemTunnelType == "7") {
      this.srcPath =
        hostName +
        "/tunnelModelSxdXj?id=" +
        getRandomNumber(1000) +
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
    } else {
      this.srcPath =
        hostName +
        "/tunnelModelLeft?id=" +
        getRandomNumber(1000) +
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
    }
  },
  methods: {
    formatMileageUint,
    formatDateAll,
    formatDateHis,
    handlePercentage,
    getGasNetworkings() {
      let that = this;
      getGasNetworking({ itemId: that.TunnelsData.itemId }).then((res) => {
        if (res.status == 200) {
          res.data.data.forEach((item) => {
            item.gasTypes.forEach((itemType) => {
              that.gasNetworkingDataAll.push({
                regional: item.name,
                position: "掌子面",
                name: itemType.name,
                nameAlias: itemType.nameAlias,
                value: 0,
                unit: itemType.unitName,
                highAlarmValue: itemType.highAlarmValue,
                lowAlarmValue: itemType.lowAlarmValue,
                openAlarmValue: itemType.openAlarmValue,
                openHighAlarm: itemType.openHighAlarm,
                openLowAlarm: itemType.openLowAlarm,
                alarmValue: itemType.alarmValue,
                maxValue: itemType.maxValue,
                minValue: itemType.minValue,
                tunnelId: item.id,
                tunnelNumber: item.tunnelNumber,
                creationTime: "",
              });
            });
          });
          that.getGasList();
        }
      });
    },
    // 获取出勤数据
    getAttendanceData() {
      let that = this;
      attendanceData({ itemId: that.TunnelsData.itemId }).then((res) => {
        if (res.data.code == 200) {
          that.AttendData.jobNumber = res.data.data.jobNumber; // 在职人员人数
          that.AttendData.wordNumber = res.data.data.wordNumber; // 当前洞内人数
          that.AttendData.data = res.data.data.data; // 数据
        } else {
          console.error(res.message);
        }
      });
    },
    // 获取人员车辆数据
    getHumanMachine() {
      let that = this;
      humanMachine({ itemId: that.TunnelsData.itemId }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.code != 200) {
            console.error(res.data.message);
            return false;
          }
          that.humanMachineData.personnelNumber = res.data.data.personnelNumber; // 人员数量
          that.humanMachineData.carNumber = res.data.data.carNumber; // 车辆数量
          that.humanMachineData.personnelData = res.data.data.personnelData; // 人员数据
          that.humanMachineData.carData = res.data.data.carData; // 车辆数据

          let seriesData = [];
          res.data.data.personnelData.forEach((item) => {
            seriesData.push({
              value: item.value,
              name: item.name.split("（")[0],
            });
          });

          // 初始化图表
          this.myChart = echarts.init(
            document.getElementById("main_Personnel")
          );
          this.initChart(this.myChart, seriesData);
        } else {
          console.error(res.message);
        }
      });
    },
    // 获取气体数据
    getGasList() {
      let that = this;
      if (that.tunnelData[that.nun] === undefined) {
        return;
      }

      gasData({ tunnelNumber: that.tunnelData[that.nun].tunnelNumber }).then(
        (res) => {
          if (res.data.code != 200) {
            console.error(res.message);
            return false;
          }

          that.gasNetworkingData = that.gasNetworkingDataAll.filter(
            (item) =>
              item.tunnelNumber === that.tunnelData[that.nun].tunnelNumber
          );
          that.gasNetworkingData.forEach((item) => {
            res.data.data.forEach((items) => {
              if (items.name === item.name) {
                item.value = items.value;
                item.time = formatDateHis(items.time);
              }
            });
          });
        }
      );
    },
    getDataList(name, value, unit, regional) {
      this.gasDataList.push({
        name: name,
        value: value,
        unit: unit,
        time: formatDateHis(),
        regional: regional,
      });
    },
    initChart(myChart, seriesData) {
      const option = {
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        toolbox: {
          show: false,
        },
        calculable: true,
        series: [
          {
            name: "",
            type: "pie",
            center: ["35%", "50%"], // 调整位置避免超出
            radius: ["50%", "70%"],
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
              },
              emphasis: {
                label: {
                  show: true,
                  position: "center",
                  textStyle: {
                    fontSize: "30",
                    fontWeight: "bold",
                  },
                },
              },
            },
            data: seriesData,
          },
        ],
      };

      myChart.setOption(option);
    },

    // 窗口大小变化时调整图表
    handleResize() {
      const baseWidth = 1920;
      const baseHeight = 1080;
      const scale = Math.min(
        window.innerWidth / baseWidth,
        window.innerHeight / baseHeight
      );
      // 最小 12px，最大 24px
      const fontSize = Math.max(12, Math.min(24, 16 * scale));
      document.documentElement.style.fontSize = `${fontSize}px`;

      if (this.myChart) {
        this.myChart.resize();
      }
    },
    handleTunnelClick(direction, num) {
      this.itemTunnelTypeNUm = num;
      this.nun = direction;
      this.nun = Math.max(0, Math.min(this.nun, this.tunnelData.length - 1));
    },
    // 新增里程转换方法
    formatMileage(mileage) {
      if (typeof mileage !== "number") {
        mileage = parseFloat(mileage);
      }
      if (isNaN(mileage)) {
        return "";
      }
      const km = Math.floor(mileage / 1000);
      const m = mileage % 1000;
      return `DK${km}+${String(m.toFixed(2)).padStart(3, "0")}`;
    },
    customSecondliningFormat(percentage) {
      return `${this.tunnelData[this.nun]?.excavationJumboData?.mileage}/${this.tunnelData[this.nun]?.tunnelLength}`;
    },
    customInvertedarchFormat(percentage) {
      return `${this.tunnelData[this.nun]?.invertedarchData?.mileage}/${this.tunnelData[this.nun]?.tunnelLength}`;
    },
    customExcavationFormat(percentage) {
      return `${this.tunnelData[this.nun]?.secondliningJumboData?.mileage}/${this.tunnelData[this.nun]?.tunnelLength}`;
    },
  },
  beforeDestroy() {
    // 移除事件监听，销毁图表
    window.removeEventListener("resize", this.handleResize);
    if (this.myChart) {
      this.myChart.dispose();
    }
    // 离开页面时清除定时器
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
};
</script>

<style scoped>
/* >>> 全局变量 */
:root {
  --primary-color: #adcc25;
  --active-color: #7bf7a0;
}

/* 主容器：12列网格，固定 5px 间距 */
.cloud-Detail {
  display: grid;
  grid-template-columns: repeat(12, 1fr); /* 12等分 */
  grid-template-rows: repeat(12, 1fr);
  gap: 5px; /* 👈 固定 5px 间距，不随缩放变化 */

  width: 100vw;
  height: calc(100vh - 11vh); /* 减去顶部 11% */
  padding: 10px; /* 外边距固定 */
  box-sizing: border-box;
  background: transparent;
  color: #fff;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  position: relative;
}

/* 面板通用样式 */
.panel {
  background: rgba(0, 0, 0, 0.4);
  border-radius: 6px;
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
}

.panel-header {
  height: 1.85rem;
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
}

.panel-header img {
  width: 100%;
  height: auto;
  display: block;
}

.panel-header p:nth-child(2) {
  position: absolute;
  top: 0.3rem;
  left: 1.05rem;
  font-size: 1rem;
  color: #fff;
  margin: 0;
}

/* 隧道 tabs */
.tunnel-tabs {
  position: absolute;
  top: 0.225rem;
  right: 0;
  display: flex;
  gap: 5px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.tunnel-tabs li {
  width: 2.3875rem;
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  font-size: 0.875rem;
  color: var(--primary-color);
  cursor: pointer;
}

.tunnel-tabs .active {
  color: #7bf7a0;
}

.panel-body {
  padding: 0.75rem;
  flex: 1;
  overflow: hidden;
}

/* 安全天数 */
.safety-day {
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
}
.safety-day img {
  width: 95%;
  margin: 0 auto 0.5rem;
  display: block;
}
.safety-day p:nth-child(2) {
  font-weight: bold;
  font-size: 1.5rem;
  color: #ebff36;
  position: absolute;
  top: 1rem;
  width: 100%;
  margin: 0;
}
.safety-day p:nth-child(2) span {
  font-size: 0.875rem;
  color: #fff;
  font-weight: normal;
}
.safety-day p:nth-child(3) {
  font-size: 0.75rem;
  color: #fff;
  position: absolute;
  top: 3.625rem;
  width: 100%;
  margin: 0;
}

/* 信息项 */
.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 0.875rem;
}
.label {
  color: rgba(255, 255, 255, 0.6);
  width: 45%;
  text-align: left;
}
.value {
  width: 55%;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 进度 */
.progress-info {
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}

/* 台车列表 */
.jumbo-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.jumbo-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  min-height: 2rem;
}
.jumbo-list li img {
  width: 0.75rem;
  flex-shrink: 0;
}
.jumbo-list li p {
  margin: 0;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

/* >>> 关键：调整面板位置和跨度 */

/* 左侧三面板：占第 1-2 列 */
.cloud-detail-title {
  grid-column: 1 / span 2;
  grid-row: 1 / span 4;
}
.cloud-detaillz-title {
  grid-column: 1 / span 2;
  grid-row: 5 / span 2;
}
.cloud-detailbottom-title {
  grid-column: 1 / span 2;
  grid-row: 7 / span 6;
}

/* 中间地图：占第 3-10 列（共 8 列）*/
.map-iframe {
  grid-column: 3 / span 8;
  grid-row: 1 / span 12;
  border: none;
  width: 100%;
  height: 100%;
}

/* 右侧三面板：占第 11-12 列 */
.cloud-detailTightTop-title {
  grid-column: 11 / span 2;
  grid-row: 1 / span 3;
}
.cloud-detailTightZj-title {
  grid-column: 11 / span 2;
  grid-row: 4 / span 5;
}
.cloud-detailTightBottom-title {
  grid-column: 11 / span 2;
  grid-row: 9 / span 4;
}

/* 人机管理内部 */
.flex-row {
  display: flex;
  gap: 0.75rem;
  height: 100%;
}
.chart-container {
  width: 60%;
}
.personnel-toggle {
  width: 40%;
}
.toggle-buttons {
  display: flex;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
}
.toggle-buttons p {
  background: transparent;
  border: 1px solid #0060ff;
  color: #fff;
  padding: 0.25rem;
  border-radius: 0.125rem;
  font-size: 0.75rem;
  text-align: center;
  cursor: pointer;
  flex: 1;
}
.toggle-buttons .active {
  background: #2289ff;
  box-shadow: 0 0 0.9375rem 0.1875rem rgba(34, 137, 255, 0.8);
  border-color: #2289ff;
}
.detail-list {
  list-style: none;
  padding: 0;
  max-height: 16vh;
  overflow-y: auto;
}
.detail-list li {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  height: 1.5rem;
}
.dot {
  width: 0.625rem;
  height: 0.625rem;
  background: #0060ff;
  border-radius: 50%;
  margin-right: 0.375rem;
}

/* 气体监控 */
.gas-table-header,
.gas-table-row {
  display: grid;
  grid-template-columns: 22% 20% 20% 18% 20%;
  gap: 0.125rem;
  height: 1.5rem;
  align-items: center;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
}
.gas-table-header {
  font-weight: bold;
  margin-top: 0.75rem;
}
.scroll-container {
  height: 26vh;
  margin-top: -0.5rem;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
}
.scroll-list {
  list-style: none;
  padding: 0;
  animation: scrollUp 10s linear infinite;
}
.scroll-container:hover .scroll-list {
  animation-play-state: paused;
}

@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(calc(-50%)); /* 滚动一半，因为内容被复制了 */
  }
}

/* 出勤人员 */
.job-count {
  display: flex;
  justify-content: space-between;
  background: linear-gradient(
    90deg,
    rgba(0, 87, 242, 0.8) 0%,
    rgba(0, 87, 242, 0.24) 100%
  );
  padding: 0.5rem;
  border-radius: 0.125rem;
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
}
.attend-row {
  display: grid;
  grid-template-columns: 22% 32% 25% 21%;
  gap: 0.125rem;
  height: 1.5rem;
  align-items: center;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 0.5rem;
}

/* Element UI 兼容 */
::v-deep .el-progress__text {
  font-size: 0.875rem !important;
}
</style>